import { Controller } from "@hotwired/stimulus"

// Client-side category filter for the bell notification panel. Tab buttons
// carry data-category ("all" | "new_episode" | "new_event" | "suggested_job");
// rows carry the same. Clicking a tab toggles row visibility and swaps active
// pill styling. No re-fetch — the panel is loaded once per open. Defaults to
// "All" on connect. Opening the Jobs tab POSTs to markReadUrlValue once to
// mark all unread suggestions read server-side.
export default class extends Controller {
  static targets = ["tab", "item", "empty"]
  static values  = { markReadUrl: String }

  static ACTIVE   = ["bg-primary-fixed", "text-on-primary-fixed"]
  static INACTIVE = ["bg-surface-container-low", "text-on-surface-variant", "border", "border-outline-variant/30"]

  connect() {
    this._markedRead = false
    const initial = this.tabTargets.find((t) => t.dataset.category === "all") || this.tabTargets[0]
    if (initial) this.activate(initial.dataset.category)
  }

  select(event) {
    this.activate(event.currentTarget.dataset.category)
  }

  activate(category) {
    this.tabTargets.forEach((tab) => this.setActive(tab, tab.dataset.category === category))

    let visible = 0
    this.itemTargets.forEach((li) => {
      const show = category === "all" || li.dataset.category === category
      li.classList.toggle("hidden", !show)
      if (show) visible++
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible !== 0)

    // Mark job suggestions read when the Jobs tab is opened (once per panel load).
    if (category === "suggested_job" && this.hasMarkReadUrlValue && !this._markedRead) {
      this._markedRead = true
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      fetch(this.markReadUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": token, "Accept": "application/json" },
        credentials: "same-origin"
      }).catch(() => {})
      // Hide the Jobs tab badge now that suggestions are being read.
      const jobsTab = this.tabTargets.find((t) => t.dataset.category === "suggested_job")
      if (jobsTab) {
        const badge = jobsTab.querySelector("span")
        if (badge) badge.classList.add("hidden")
      }
    }
  }

  setActive(tab, on) {
    tab.setAttribute("aria-pressed", on ? "true" : "false")
    const { ACTIVE, INACTIVE } = this.constructor
    tab.classList.add(...(on ? ACTIVE : INACTIVE))
    tab.classList.remove(...(on ? INACTIVE : ACTIVE))
  }
}
